export default "__VITE_ASSET__YOwb3M$n__"